// 일일 숙제 3종 헬퍼 (모바일 포팅 — 웹 lib/dailyQuests.js 이식)
// - track_daily_quest RPC로 슬롯(login/vote/contribute) 갱신
// - 3슬롯 완주 시 서버가 +30 EXP 지급 → completed_bonus_granted 반환 → 토스트

// 위젯 재조회 트리거 이벤트 — trackDailyQuest 성공 시 dispatch
export const DAILY_QUEST_UPDATED = "sotda_daily_quest_updated";

export type QuestSlot = "login" | "vote" | "contribute";

export type DailyQuestState = {
  slot_login: boolean;
  slot_vote: boolean;
  slot_contribute: boolean;
  completed_at?: string | null;
  completed_bonus_granted?: boolean;
};

export function emptyQuestState(): DailyQuestState {
  return {
    slot_login: false,
    slot_vote: false,
    slot_contribute: false,
    completed_at: null,
  };
}
